/**
 * Pushes an event to the GTM dataLayer (see GTM-TR86L7BX snippet in app.blade.php).
 * GTM/GA4 is already loaded site-wide; this is the missing piece that actually
 * feeds it conversion-relevant events (CTA clicks, form start/submit, WhatsApp, project opens).
 */
export function trackEvent(event, params = {}) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}
